import React from 'react'
import withStyles from "@material-ui/core/styles/withStyles";
import avatar from "assets/img/faces/avatar.jpg";

import UserAvatarStyle from 'assets/jss/material-dashboard-pro-react/views/userAvatar.jsx'
const UserAvatar=(props)=>{
  const {classes}=props;
  return (
    <div className={classes.photo}>
      <img src={avatar} className={classes.avatarImg} alt="..." />
    </div>
  )
}
export default withStyles(UserAvatarStyle)(UserAvatar)



// WEBPACK FOOTER //
// ./src/views/Users/Avatar.jsx